import { FileField } from "@f2e/ui/components/InteractionRequestForm"
import type { FormRequestField } from "@f2e/shared/types"
import { BaseFieldEditor } from "./BaseFieldEditor"
import type { FieldEditorProps, FieldRendererProps } from "./fieldRegistry"

export const FileFieldEditor = ({
  field,
  onChange,
  disabled,
}: FieldEditorProps) => (
  <BaseFieldEditor
    field={{ ...field }}
    onChange={onChange}
    disabled={disabled}
    showPlaceholder={false}
  />
)

export const FileFieldRenderer = ({ field }: FieldRendererProps) => (
  <FileField
    field={field as unknown as FormRequestField}
    value={null}
    disabled
  />
)
